<div class="mat-typography" [formGroup]="saveRiskReportGroup" [ngStyle]="{width: hasPoints? '600px': '650px', overflow: 'auto'}">
  <div class="dialog-header">
    Generate Exposure Report
  </div>

  <div class="horizontal-separator"></div>

  <div class="dialog-container">
    <ng-container>
      <!--            <frmg-info-block type="warning" [title]="warningTitle" [body]="warningBody"/>-->


      <!--            <p class="section-title" style="margin-top: 10px">General Settings</p>-->
      <div class="card-block">
        <p class="input-label" style="margin-top: 0">
          Name of the report
        </p>
        <mat-form-field appearance="outline">
          <input matInput formControlName="name" placeholder="Name of the report" required>
          @if (saveRiskReportGroup.get('name')?.hasError('required')) {
            <mat-error>
              Name is required
            </mat-error>
          }
        </mat-form-field>
        <p class="input-label">
          Layer Selection
        </p>
        <p class="input-hint">
          Please enable at least one layer to proceed. Select the
          classes or range of each layer you wish to
          display on the report.
        </p>
        <div formArrayName="layersThresholds">
          @for (layer of getLayersThresholdsControls(); track layer) {
            <div class="card-shadow" [formGroup]="layer">
              <p class="input-label">
                <span>{{ capitalizeFirstLetter(layer.value.name) }}</span>
                <inline-svg src="info.svg"  class="info-icon"
                  color="#A5B5BD" hoverColor="#85BBF3"
                [matTooltip]="riskTooltip" matTooltipPosition="left"></inline-svg>
                <!--                                <span class="icon icon-info" [matTooltip]="riskTooltip" matTooltipPosition="left"></span>-->
                <span class="spacer"></span>
                <mat-slide-toggle
                  formControlName="enabled"
                  labelPosition="before">
                </mat-slide-toggle>
              </p>
              <div class="horizontal-separator"
              [ngClass]="{ expandable: !layer.getRawValue().enabled }"></div>
              @if (!layer.value.discrete) {
                <div class="invert-container" [ngClass]="{ expandable: !layer.getRawValue().enabled }">
                  <mat-checkbox formControlName="inverted"></mat-checkbox>
                  Invert
                </div>
              }
              @if (!layer.value.discrete) {
                <div class="slider-container expandable-base"
                  [ngClass]="{ expandable: !layer.getRawValue().enabled }">
                  <mat-slider
                    class="threshold-slider  risk-slider"
                    [ngClass]=" {'inverted': layer.value.inverted}"
                    [max]="layer.value.max"
                    [min]="layer.value.min"
                    step="1">
                    <div class="threshold-slider-range">
                      <span>{{ layer.value.min }}</span>
                      <span>{{ layer.value.max }}</span>
                    </div>
                    <input matSliderStartThumb formControlName="threshold"
                      [value]="layer.value.threshold">
                      <input matSliderEndThumb formControlName="thresholdMax"
                        [value]="layer.value.thresholdMax">
                      </mat-slider>
                      <div class="input-container">
                        <mat-form-field appearance="outline" class="threshold-input">
                          <input matInput formControlName="threshold" placeholder="{{layer.value.min }}"
                            [value]="layer.value.threshold">
                          </mat-form-field>
                          <span>-</span>
                          <mat-form-field appearance="outline" class="threshold-input">
                            <input matInput formControlName="thresholdMax"
                              placeholder="{{layer.value.min }}"
                              [value]="layer.value.thresholdMax">
                            </mat-form-field>
                          </div>
                        </div>
                      }
                      @if (layer.value.discrete && getLayersLegendsControls(layer).length > 2) {
                        <div class="legends-container"   formArrayName="legends" [ngClass]="{ expandable: !layer.getRawValue().enabled }" >
                          @for (legend of getLayersLegendsControls(layer); track legend) {
                            <div [formGroup]="legend">
                              <mat-checkbox formControlName="enabled"></mat-checkbox>
                              <span>{{ legend.getRawValue().label }}</span>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>

            </ng-container>
</div>

</div>
<div class="button-row ">
  <ng-container>
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-button cdkFocusInitial class="frmg-primary-button"
      [disabled]="saveRiskReportGroup.invalid || isLoading"
      (click)="save()">Generate Exposure Report
    </button>
  </ng-container>
</div>
